Vgr.enumerations = {
	validation: {
		//Driver validations
		DriverLicenseWithoutExpirationDate: 1,
		DriverLicenseExpired: 2,
		DriverWithoutMopp: 3,
		DriverMoppExpired: 4,
		DriverRequired: 174,

		//Vehicle validations
		VehicleWithoutInmetroCertificate: 5,
		VehicleWithInmetroCertificateExpired: 6,
		VehicleRequired: 175,

		NoAuthDocumentSelected: 7,
		AuthDocumentDontContemplatesAllResidues: 8,
		AuthDocumentExpired: 9,
		ResidueQuantityExceededAuthValue: 10,
		AuthDocumentWithDifferentDisposalTechnology: 11,
		AuthDocumentWithDifferentRecipient: 12,
		ResidueQuantityIsRequired: 13,
		ResidueMeasureUnitInvalid: 14,
		TransporterIsRequired: 15,
		NoCadriSelected: 16,
		CadriDocumentExpired: 17,
		CadriDocumentDontContemplatesAllResidues: 18,
		ResidueWithoutIbamaCode: 19,
		AuditDestinatorLevelInvalid: 20,
		AuditDestinatorClassificationInvalid: 21,
		AuditTransporterLevelInvalid: 22,
		AuditTransporterClassificationInvalid: 23,
		ResidueRequired: 28,
		RecipientRequired: 30,
		DisposalTechRequired: 32,
		RequestDateRequired: 48,
		FutureDateNotAllowed: 49,
		CadriDocumentNotFound: 54,
		RecipientQuantityIsRequired: 76,
		TemporaryStoragerRequired: 93,
		TemporaryStoragerNotFound: 94,
		TemporaryStoragerAuditLevelInvalid: 95,
		TemporaryStoragerAuditClassificationInvalid: 96,
		DisposalWithExternalIntegrationCantChangeDestinator: 98,
		QuantityBelowMinimumQuantity: 108,
		QuantityAboveMaximumQuantity: 109,
		RequestDateBeforeMinAllowedDate: 110,
		GatheringDateBeforeMinAllowedDate: 111,
		LimitDaysForDisposalEditionExceeded: 112,
		LimitDaysForDisposalCreationExceeded: 113,
		ResidueMustBeActive: 116,
		GatheringIsLocked: 117,
		AuthDocumentInactive: 134,
		CadriDocumentInactive: 135
	},

	measureUnit: {
		Group: {
			Mass: 2
		},
		Unit: {
			Kg: 108
		}
	},

	loginState: {
		notLogged: 1,
		loggingIn: 2,
		loggingInOnIdp: 6,
		loggingOut: 3,
		logged: 4,
		loginError: 5,
		loggedNewPasswordRequired: 7
	},

	supplier: {
		type: {
			Destinator: 1,
			Transporter: 2,
			TemporaryStorager: 3
		}
	},

	scaling: {
		type: {
			OneStep: 1,
			TwoSteps: 2,
			TwoStepsWithStorage: 3
		},
		process: {
			Storage: 1,
			Disposal: 2
		}
	},

	httpErrorCode: {
		BadRequest: 400
	},

	additionalProperty: {
		type: {
			FreeText: "Text",
			SuspendList: "List"
		},
		process: {
			InternalGathering: "ResidueGeneration",
			Disposal: "Disposal",
			Area: "Area",
			OrganizationUnit: "OrganizationUnit"
		}
	},
	destination: {
		model: {
			Complete: 1,
			Export: 3,
			TemporaryStorage: 4
		},

		status: {
			Requested: 1,
			Gathered: 2,
			Received: 3,
			Pending: 4,
			Finalized: 5,
			TemporaryStorageReceived: 6,
			Canceled: 7
		},

		invoiceStatus: {
			Valid: 1,
			Canceled: 2
		},

		disposalCostType: {
			CostByDisposal: 2,
			CostByResidue: 1
		},

		pendencyType: {
			MTR: 1,
			CDF: 2,
			Invoice: 3
		},

		notification: {
			Destinator: 1,
			Transporter: 2,
			MTR: 3
		},

		file: {
			Invoice: 1,
			GeneralDocument: 2,
			Manifest: 3,
			CDF: 4,
			ComplementaryMtr: 5
		},

		calculatedDisposalFileTypes: {
			Invoice: "Invoice",
			GeneralDocument: "GeneralDocument",
			Manifest: "Manifest",
			DisposalCertificate: "DisposalCertificate",
			ComplementaryMtr: "ComplementaryMtr"
		},

		systemSource: {
			SINIR_BR: 6,
			SIGOR_SP: 7,
			SGA_PR: 8,
			SGORS_AL: 11
		},

		systemStatus: {
			Pending: 1,
			Created: 2,
			Received: 3,
			Disposed: 4,
			Canceled: 5,
			Provisional: 6,
			ReceivedTemporaryStorage: 7,
			ComplementaryMTREmitted: 8,
			CanceledByDeadline: 9,
			Refused: 10
		},

		calculatedSystemStatus: {
			Pending: "Pending",
			Created: "Created",
			Received: "Received",
			Disposed: "Disposed",
			Canceled: "Canceled",
			Provisional: "Provisional",
			ReceivedTemporaryStorage: "ReceivedTemporaryStorage",
			ComplementaryMTREmitted: "ComplementaryMTREmitted",
			Refused: "Refused",
			Processing: "Processing",
			PendingConfirmReceival: "PendingConfirmReceival",
			CanceledByDeadline: "CanceledByDeadline"
		},

		stages: {
			Solicitation: 0,
			Gathering: 1,
			Tracking: 2,
			InTemporaryStorage: 3,
			Arrival: 4,
			Confirmation: 5
		},

		steps: {
			A: 0,
			B: 1,
			C: 2,
			D: 3,
			E: 4,
			F: 5,
			G: 6,
			H: 7
		},

		alertMessages: {
			invalidGatheringDate: 0,
			gatheringIsLocked: 1,
			destinatorPendenciesAlert: 2
		},

		validationType: {
			Driver: 0,
			Vahicle: 1,
			Document: 2
		},

		validations: {
			suppliers: {
				key: "SupplierType",
				atuation: {
					Destinator: "Destinador",
					Transporter: "Transportador",
					TemporaryStorager: "Armazenador Temporário"
				}
			}
		}
	},

	stockControl: {
		adjustmentTypes: {
			DecreaseResidueGeneration: 1,
			MaintainResidueGeneration: 2
		},

		controlType: {
			ExactQuantity: 1,
			RecipientQuantity: 2
		}
	},

	systemPermissions: {
		types: {
			Master: 0,
			Organization: 1,
			OrganizationUnit: 2
		}
	},

	internalGathering: {
		internalTransferType: {
			NoTransfer: "NoTransfer",
			TwoStepTransfer: "TwoStepTransfer",
			FullTransfer: "FullTransfer"
		}
	},

	userAccess: {
		Enabled: 1,
		Disabled: 2,
		Hidden: 3
	},

	messageTypes: {
		REDIRECT_SINGLETON: "REDIRECT_SINGLETON",
		SYNC_LOCAL_STORAGE: "SYNC_LOCAL_STORAGE",
		SET_LANGUAGE: "SET_LANGUAGE",
		SET_BEARER_TOKEN: "SET_BEARER_TOKEN"
	},
	channel: {
		disposal: {
			dataLoad: 1,
			disposalScreenWithoutModel: 4,
			mtrImport: 5,
			disposalScreenHistory: 6
		}
	},
	vertownNotifications: {
		types: {
			popup: "Popup",
			alert: "Alert"
		},
		severity: {
			danger: "Danger",
			warning: "Warning",
			informative: "Informative"
		},
		displayBehavior: {
			remindLater: "RemindLater"
		},
		supportTextTypes: {
			admin: "Admin",
			support: "Support"
		}
	},
	systemFeatures: {
		residuesManagement: "4B07A4BF-7241-4878-8EBA-C4EF992D71F9",
		supplierView: "E0435D73-DE48-4162-B661-C6FAB20BAF3C",
		PGRS: "C42CFD74-DCC9-4C1B-A41D-630C89415593",
		executiveReports: "FC14750E-BD89-4D3A-9265-BDE80CDED994",
		dnitIntegration: "1DBE85DB-E476-4E84-BABB-4E9255EADBD9",
		ibamaRappIntegration: "3A990770-6BD0-422D-8D88-A3259812F169"
	},
	createDisposal: {
		model: {
			temporaryStorager: "armazenamento-temporario"
		},
		origin: {
			history: "historico"
		}
	}
};
